import template from './rooms-count.jade';
import validation from './../../../services/validation';
import roomsCount from './../../../enums/rooms-count';

import { initializeSegmentInputTooltips } from '../../../utils/segment-input-tooltips';
import { selectAnalyticsOfferStatus } from '../../../../../../shared/selectors/analytics';
import { trackRequiredFieldFill } from '../../../../../../shared/utils/tracking/requiredFields';

export default angular.module('cian.addForm.roomsCount', []).directive('cianAfAboutObjectRoomsCount', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller: [
    '$scope',
    'adStateService',
    'isSimpleFormEnabled',
    'adTooltipsService',
    'analyticsService',
    'deviceService',
    'popupService',
    'store',
    function (
      $scope,
      adStateService,
      isSimpleFormEnabled,
      adTooltipsService,
      analyticsService,
      deviceService,
      popupService,
      store,
    ) {
      this.isMobile = deviceService.isMobile;
      this.modalHintTitle = 'Количество комнат';
      this.isSimpleFormEnabled = isSimpleFormEnabled;
      this.tooltipText = '';
      // todo: переделать - false по дефолту и добавить это поле в общий механизм очистки неактуальных полей
      const deregisterOnCleanHandler = adStateService.onCleanAdModel(function (event, ad) {
        if (!ad.isPenthouse) {
          ad.isPenthouse = false;
        }
      });
      $scope.$on('$destroy', deregisterOnCleanHandler);

      const getSelectedRoomsCountOption = () => {
        if (this.ad.flatType === 'rooms') {
          return this.ad.roomsCount;
        }

        return this.ad.flatType;
      };

      const getServerValues = () => {
        if (this.selectedRoomsCountOption === 'openPlan') {
          return ['openPlan', undefined];
        } else if (this.selectedRoomsCountOption === 'studio') {
          return ['studio', undefined];
        }

        return ['rooms', this.selectedRoomsCountOption];
      };

      this.roomsCountOptions = roomsCount;

      this.selectedRoomsCountOption = getSelectedRoomsCountOption();

      this.validation = validation(this.form, 'roomsCount', {
        required: 'Выберите значение',
      });

      this.onChange = () => {
        const state = store.getState();
        const category = selectAnalyticsOfferStatus(state);

        [this.ad.flatType, this.ad.roomsCount] = getServerValues();

        trackRequiredFieldFill(category, 'number_of_rooms');
      };

      initializeSegmentInputTooltips({
        controller: this,
        $scope,
        adTooltipsService,
        adAnalyticsCategory: analyticsService.adAnalyticsCategory,
        tooltipsKey: 'roomsCount',
        trackingLabel: 'rooms-count-hint',
        popupService,
        isMobile: this.isMobile,
      });
    },
  ],
  controllerAs: 'roomsCount',
  template,
})).name;
